// https://sistemas.ucasal.edu.ar/sagbackend/api/v1/registro-inicial/lovs/modos2?tipo-estudio=Grado&carrera=${id_carrera}&lugar=${id_lugar}


import { SERVICES_URL } from "../../config/config";
import { connection } from "../../utils/connection";


const getListModes = async ({ token, callbacks, params }) => {
    
    //const response = await connection({ method: 'GET', url: `${SERVICES_URL.MODES.LIST}`, token, params });
    const res= await fetch(`${SERVICES_URL.MODES.LIST}?tipo-estudio=${params.tipoEstudio}&carrera=${params.carrera}&lugar=${params.lugar}`,{
        headers: {
            'auth': token,
        }
    })

    //const data = await res.json();
    //console.log(data)

    //const res= await fetch(SERVICES_URL.MODES.LIST+'?lugar='+params.lugar+'&tipo-estudio='+params.tipoEstudio+'&carrera='+params.carrera)
    //const data = await res.json();

    if (typeof callbacks === "function") {
        //callbacks(data);
        if (res.status == 200){
            callbacks({
                success: true,
                data: await res.json()
            })
        }else{
            callbacks({
                success: false,
                error: await res.json()
            });
        }
    }
}

export default getListModes;

